import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Cart = (item) => {
  const [cart, setCart] = useState([]);
  const [quantities, setQuantities] = useState({});
  const basePrice = 200;

  const [shippingMethod, setShippingMethod] = useState({
    id: "free_shipping:1",
    name: "Free Shipping",
    cost: 0,
    number: "",
  });

  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem("cart")) || [];
    setCart(storedCart);

    const initialQuantities = storedCart.reduce((acc, item) => {
      acc[item.id] = 1;
      return acc;
    }, {});
    setQuantities(initialQuantities);
  }, []);

  const removeFromCart = (id) => {
    const updatedCart = cart.filter((item) => item.id !== id);
    setCart(updatedCart);
    localStorage.setItem("cart", JSON.stringify(updatedCart));
    window.dispatchEvent(new Event("cartUpdated"));

    const updatedQuantities = { ...quantities };
    delete updatedQuantities[id];
    setQuantities(updatedQuantities);
  };

  const increment = (id) => {
    setQuantities((prev) => ({
      ...prev,
      [id]: Math.min(prev[id] + 1, 15),
    }));
  };

  const decrement = (id) => {
    setQuantities((prev) => ({
      ...prev,
      [id]: Math.max(prev[id] - 1, 1),
    }));
  };

  const totalPrice = cart.reduce((total, item) => {
    return total + quantities[item.id] * basePrice;
  }, 0);

  const tprice = totalPrice + shippingMethod.cost;

  const qnt = cart.reduce((total, item) => {
    return total + quantities[item.id];
  }, 0);

  const pqnt = cart.reduce((id, item) => {
    return quantities[item.id];
  }, 0);

  return (
    <>
      <section className="card_section">
        <div className="container-fluid">
          <div className="row">
            <div className="main_cartsec">
              <div className="cartbox1">
                <Link to="/cart">Shopping Cart</Link>
              </div>
              <div className="cartbox2">
                {" "}
                <Link to="/">Checkout</Link>
              </div>
            </div>
            <div className="col-lg-9 col-md-12">
              <div className="box_cart">
                <div className="box_cart_1">
                  <h6>Product</h6>
                  <h6>Price</h6>
                  <h6>Quantity</h6>
                  <h6>Subtotal</h6>
                </div>
                <hr className="cart_hr" />

                <hr className="cart_hr" />

                {cart?.map((item) => (
                  <div key={item.id} className="detail_porduct_boxcart">
                    <div className="box-img-cart">
                      <img
                        src={item.image}
                        alt={item.name}
                        className="img-product"
                      />
                    </div>

                    <div className="detail_producttext">
                      <Link to="">{item.name}</Link>
                    </div>

                    <div className="detail_product-price">${basePrice}</div>

                    <div className="quantity-content-cart">
                      <div className="quantity">
                        <button
                          type="button"
                          className="plus"
                          onClick={() => increment(item.id)}
                        >
                          +
                        </button>
                        <button className="plus">{quantities[item.id]}</button>
                        <button
                          type="button"
                          className="minus"
                          onClick={() => decrement(item.id)}
                        >
                          -
                        </button>
                      </div>
                    </div>

                    <div className="detail_product-price">
                      ${quantities[item.id] * basePrice}
                    </div>

                    <div className="product-remove_box">
                      <div className="product-remove">
                        <Link
                          to=""
                          className="remove"
                          onClick={() => removeFromCart(item.id)}
                        >
                          x
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}

                <hr className="cart_hr" />
                <div className="mainbox_coupon">
                  <div className="coupon">
                    <input
                      type="text"
                      className="input-text"
                      id="coupon_code"
                      placeholder="Coupon code"
                    />
                    <button
                      type="submit"
                      className="Apply_coupon"
                      name="apply_coupon"
                      value="Apply coupon"
                    >
                      Apply coupon
                    </button>
                  </div>
                  <div className="Continue_Shopping_box">
                    <h2 style={{ paddingLeft: "10px" }}>
                      <Link to="">Continue Shopping</Link>
                    </h2>
                    <button
                      type="submit"
                      className="Update_cart"
                      name="apply_coupon"
                      value="Apply coupon"
                      style={{ width: "130px" }}
                    >
                      Update cart
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-12">
              <div className="mainbox_Cart_totals">
                <div className="Cart_totals">
                  <h6>Cart totals</h6>
                </div>
                <div className="cart-subtotal">
                  <div className="title">Subtotal</div>
                  <div data-title="Subtotal">
                    <span className="woocommerce-Price-amount amount">
                      <bdi>
                        <span className="woocommerce-Price-currencySymbol">
                          ${totalPrice}
                        </span>
                      </bdi>
                    </span>
                  </div>
                </div>
                <div className="totals_shipping">
                  <h2>Shipping</h2>
                  <div data-title="Shipping">
                    <ul
                      id="shipping_method"
                      className="woocommerce-shipping-methods"
                    >
                      <li>
                        <input
                          type="radio"
                          name="shipping_method"
                          value="free_shipping:1"
                          className="shipping_method"
                          checked={shippingMethod.id === "free_shipping:1"}
                          onChange={() =>
                            setShippingMethod({
                              id: "free_shipping:1",
                              name: "Free Shipping",
                              cost: 0,
                            })
                          }
                        />
                        <label for="shipping_method_0_free_shipping1">
                          Free shipping
                        </label>{" "}
                      </li>
                      <li>
                        {/* <input
                    type="radio"
                    name="shipping_method"
                    value="flat_rate:2"
                    // className="shipping_method"
                    // checked={shippingMethod === 'flat_rate:2'}
                    // onChange={(e) => setShippingMethod(e.target.value)}
                    
                    onChange={() =>
                      setShippingMethod({ id: 'flat_rate:2', name: 'Flat Rate', cost: 50 })
                    }
                    
                  /> */}
                        <input
                          type="radio"
                          name="shipping_method"
                          value="flat_rate:2"
                          className="shipping_method"
                          checked={shippingMethod.id === "flat_rate:2"}
                          onChange={() =>
                            setShippingMethod({
                              id: "flat_rate:2",
                              name: "Flat Rate",
                              cost: 50,
                            })
                          }
                        />
                        <label for="shipping_method_0_flat_rate2">
                          Flat rate
                        </label>{" "}
                      </li>
                    </ul>
                    <p className="woocommerce-shipping-destination">
                      Shipping to <strong>India</strong>.{" "}
                    </p>
                  </div>
                </div>
                <div className="order-total">
                  <div className="title">Total</div>
                  <div data-title="Total">
                    <strong>
                      <span className="woocommerce-Price-amount amount">
                        <bdi className="amount_1">
                          <span className="woocommerce-Price-currencySymbol">
                            {/* {shippingMethod === 'free_shipping:1' ? `$${totalPrice}` : `$${totalPrices}`} */}
                            {tprice}
                          </span>
                        </bdi>
                      </span>
                    </strong>{" "}
                  </div>
                </div>
                <div className="Proceed">
                  <Link
                    to="/test1"
                    type="button"
                    className="wc-proceed-to-checkout"
                    style={{ textAlign: "center" }}
                    state={{
                      shippingMethod,
                      totalPrice,
                      qnt,
                      tprice,
                      basePrice,
                      pqnt,
                      cart,
                    }}
                  >
                    Proceed to checkout
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Cart;
